var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("Rosters")]),_c('router-link',{attrs:{"to":{
        name: 'rosterCreate',
        from: 'locker'
      }}},[_c('button',{staticClass:"btn btn-dark btn-block btn-add"},[_c('span',[_vm._v("Create roster")]),_c('span',{staticClass:"plusIcon"},[_vm._v("＋")])])])],1),_c('div',{staticClass:"description"},[_vm._v("\n    Create and save individual team rosters for use in current and future\n    orders.\n  ")]),_c('BBDataTable',{staticClass:"rosterContainer",attrs:{"columns":_vm.columns,"support-add-new":false,"path-url-api":"rosters","default-api-params":{
      _fields: 'rosterName,status,createdAt',
      _sort: 'createdAt',
      _order: 'desc',
      _filter: [
        {
          field: 'isDeleted',
          op: '=',
          val: 'false'
        },
        {
          field: 'user',
          op: '=',
          val: _vm.userId
        }
      ]
    }},scopedSlots:_vm._u([{key:"customButtons",fn:function(slotProps){return [_c('button',{staticClass:"btn btn-link btn-highlight btn-sm d-flex align-items-center ml-1",on:{"click":function($event){return _vm.onDuplicateItem(slotProps.props.row._id)}}},[_c('font-awesome-icon',{staticClass:"mr-2",attrs:{"icon":_vm.icons.cloneIcon}}),_c('span',{staticClass:"bb-label"},[_vm._v("Duplicate")])],1),(slotProps.props.row)?_c('router-link',{staticClass:"btn btn-link btn-highlight btn-sm d-flex align-items-center ml-1",attrs:{"to":{
          name: 'rosterEdit',
          params: { edit: true, from: 'locker', id: slotProps.props.row._id }
        }}},[_c('font-awesome-icon',{staticClass:"mr-2",attrs:{"icon":_vm.icons.editIcon}}),_c('span',{staticClass:"bb-label"},[_vm._v("EDIT")])],1):_vm._e()]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }